module.exports = __webpack_public_path__ + "img/the-netherlands-congenital-and-perinatal-diseases-female.8db9302b.png";